import type { UpsellFlowStore } from './interfaces'

import { UpsellPlacement } from '@brighterly/lib-core-types/orders/enums'

const isSkipFlow = (state: UpsellFlowStore): boolean => state.step !== 'landing'

export const getters = {
  getStep: (state: UpsellFlowStore): UpsellFlowStore['step'] => state.step,
  isSkipFlow: (state: UpsellFlowStore): boolean => isSkipFlow(state),
  isSkipOffer: (state: UpsellFlowStore): boolean => state.step === 'skip-offer',
  isSkipCheckout: (state: UpsellFlowStore): boolean => state.step === 'skip-checkout',
  isSkipNewCard: (state: UpsellFlowStore): boolean => state.step === 'skip-new-card',
  isOfferUnavailable: (state: UpsellFlowStore): UpsellFlowStore['offerUnavailable'] => state.offerUnavailable,
  getPlacement: (state: UpsellFlowStore): UpsellPlacement => isSkipFlow(state) ? UpsellPlacement.SkipModal : UpsellPlacement.Landing,
}
